import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ResourcesService } from '@wz-services';
import { FormsModels } from 'models/forms.model';

@Component({
  selector: 'wz-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss'],
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ButtonToggleComponent,
      multi: true,
    },
  ],
})
export class ButtonToggleComponent implements OnInit, ControlValueAccessor {
  @Input()
  public items: FormsModels.SelectListItem[] = [];
  @Input()
  private _value: any = null;
  @Input()
  disabled!: boolean;
  @Input()
  public orientation: 'column' | 'row' = 'row';
  @Input()
  public isNumber!: boolean;
  @Input()
  public isBoolean!: boolean;
  @Input()
  public title!: string;
  @Input()
  public fullWidth: boolean = false;
  @Input()
  public selectedValue: any;

  @Input()
  included!: any[];

  @Input()
  excluded!: any[];

  @Input()
  public set enumItemsKey(key: any) {
    this.items = this.resourcesService.getResourceEnumList(
      key,
      this.included,
      this.excluded,
    );
  }

  @Output()
  valueChange: EventEmitter<string | number | boolean> = new EventEmitter<
    string | number | boolean
  >();

  get value(): string | number | null | boolean {
    return this._value;
  }

  set value(val: string | number | boolean) {
    if (val !== this._value) {
      this._value = val;
      this.propagateChange(val);
      this.valueChange.next(val);
    }
  }

  constructor(private resourcesService: ResourcesService) {}

  ngOnInit(): void {
    this.value = this.selectedValue;
  }

  propagateChange = (_: any) => {};

  writeValue(newValue: string | number | boolean): void {
    const value = newValue === undefined || newValue === null ? '-1' : newValue;

    this._value = this.isNumber ? +value : value;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  registerOnTouched(): void {}
}
